<template>
    <div>
        <div class="grid-fitted cursor-pointer" @click="toggleFilter">
            <div class="grid-item">
                <v-icon icon="filter" class="inline-s"/>
                <span class="text-muted"
                      v-if="hasFilters">You have {{countLabel}} being applied</span>
                <span class="text-muted" v-else>No filters are being applied</span>
            </div>
            <div class="no-flex">
                <v-icon icon="caret-right" :class="{'is-rotating-right': isExpanded}"/>
            </div>
        </div>
        <div v-show="isExpanded">
            <div class="margin-top-m">
                <query2
                    @ready="$emit('ready', $event)"
                    @update="updateLocalData"
                    @validation="queryValidated"
                    :query="query"
                    :filter-set="filterSet"/>
            </div>
            <div class="divider divider-tile-content"></div>
            <div class="grid-content">
                <div class="grid-item">
                    <slot name="left-actions"/>
                </div>
                <div class="grid-item text-right">
                    <r-button class="inline-s" @click="closeFilter">Close</r-button>
                    <r-button type="primary" @click="applyFilter">Apply Filters</r-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Query2 from '@/components/query2/query2';
    import {vIcon} from '@/components/form';
    import pluralize from '@/common/helpers/pluralize';

    export default {
        name: 'grid-filter',
        components: {
            Query2,
            vIcon,
        },
        props: {
            query: [Array, Object],
            filterSet: Object,
            autoApply: {
                type: Boolean,
                default: false,
            },
            opened: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            hasFilters() {
                return this.count > 0;
            },
            countLabel() {
                return `${this.count} ${pluralize('filter', this.count)}`;
            },
        },
        watch: {
            query(query) {
                this.count = this.getCountFromQuery(query);
            },
        },
        data() {
            return {
                isExpanded: this.opened,
                count: this.getCountFromQuery(this.query),
                data: null,
                hasInvalidQuery: false,
            };
        },
        methods: {
            toggleFilter() {
                this.isExpanded = !this.isExpanded;
            },
            closeFilter() {
                this.isExpanded = false;
            },
            applyFilter() {
                this.count = this.getCountFromQuery(this.data);
                if (this.count === 0) {
                    this.closeFilter();
                }
                if (!this.hasInvalidQuery) {
                    this.$emit('update', this.data);
                } else {
                    console.warn('blocked apply');
                }
            },
            updateLocalData(data) {
                this.data = data;
                if (this.autoApply) {
                    this.applyFilter();
                }
            },
            queryValidated({hasInvalidItems}) {
                this.hasInvalidQuery = hasInvalidItems;
            },
            getCountFromQuery(data) {
                return data ? data.length : 0;
            },
        },
    };
</script>
